// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { List, Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    webExchangeGet (params?: {}): Promise<string>;
    webGetRestApi (params?: {}): Promise<string>;
    publicGetV1Symbols (params?: {}): Promise<List>;
    publicGetV1SymbolsDetailsSymbol (params?: {}): Promise<Dict>;
    publicGetV1NetworkToken (params?: {}): Promise<Dict>;
    publicGetV1StakingRates (params?: {}): Promise<Dict>;
    publicGetV1PubtickerSymbol (params?: {}): Promise<Dict>;
    publicGetV1Feepromos (params?: {}): Promise<Dict>;
    publicGetV2TickerSymbol (params?: {}): Promise<Dict>;
    publicGetV2CandlesSymbolTimeframe (params?: {}): Promise<List>;
    publicGetV1TradesSymbol (params?: {}): Promise<List>;
    publicGetV1AuctionSymbol (params?: {}): Promise<Dict>;
    publicGetV1AuctionSymbolHistory (params?: {}): Promise<List>;
    publicGetV1Pricefeed (params?: {}): Promise<List>;
    publicGetV1FundingamountSymbol (params?: {}): Promise<Dict>;
    publicGetV1FundingamountreportRecordsXlsx (params?: {}): Promise<string>;
    publicGetV1BookSymbol (params?: {}): Promise<Dict>;
    publicGetV1EarnRates (params?: {}): Promise<Dict>;
    publicGetV2DerivativesCandlesSymbolTimeFrame (params?: {}): Promise<List>;
    publicGetV2FxrateSymbolTimestamp (params?: {}): Promise<Dict>;
    publicGetV1RiskstatsSymbol (params?: {}): Promise<Dict>;
    publicGetV1PredictionMarketsEvents (params?: {}): Promise<Dict>;
    publicGetV1PredictionMarketsEventsEventTicker (params?: {}): Promise<Dict>;
    publicGetV1PredictionMarketsEventsEventTickerStrike (params?: {}): Promise<Dict>;
    publicGetV1PredictionMarketsEventsNewlyListed (params?: {}): Promise<Dict>;
    publicGetV1PredictionMarketsEventsRecentlySettled (params?: {}): Promise<Dict>;
    publicGetV1PredictionMarketsEventsUpcoming (params?: {}): Promise<Dict>;
    publicGetV1PredictionMarketsCategories (params?: {}): Promise<Dict>;
    publicGetV1PredictionMarketsVolumeDate (params?: {}): Promise<List>;
    publicGetV1PredictionMarketsVolumeDateHourly (params?: {}): Promise<List>;
    publicGetV1PredictionMarketsTerms (params?: {}): Promise<Dict>;
    publicGetV1PredictionMarketsMakerRebateRates (params?: {}): Promise<Dict>;
    publicGetV1PredictionMarketsLiquidityRewardsConfig (params?: {}): Promise<Dict>;
    publicGetV1PredictionMarketsLiquidityRewardsEvents (params?: {}): Promise<Dict>;
    privateGetV1PerpetualsFundingpaymentreportRecordsXlsx (params?: {}): Promise<string>;
    privateGetV1PredictionMarketsTermsStatus (params?: {}): Promise<Dict>;
    privateGetV1PredictionMarketsMakerRebateSummaryTotal (params?: {}): Promise<Dict>;
    privateGetV1PredictionMarketsLiquidityRewardsSummaryDaily (params?: {}): Promise<Dict>;
    privateGetV1PredictionMarketsLiquidityRewardsSummaryTotal (params?: {}): Promise<Dict>;
    privateGetV2NetworkToken (params?: {}): Promise<Dict>;
    privateGetV2NetworksNetworkAssets (params?: {}): Promise<Dict>;
    privatePostV1StakingUnstake (params?: {}): Promise<Dict>;
    privatePostV1StakingStake (params?: {}): Promise<Dict>;
    privatePostV1StakingRewards (params?: {}): Promise<Dict>;
    privatePostV1StakingHistory (params?: {}): Promise<List>;
    privatePostV1OrderNew (params?: {}): Promise<Dict>;
    privatePostV1OrderCancel (params?: {}): Promise<Dict>;
    privatePostV1WrapSymbol (params?: {}): Promise<Dict>;
    privatePostV1OrderCancelSession (params?: {}): Promise<Dict>;
    privatePostV1OrderCancelAll (params?: {}): Promise<Dict>;
    privatePostV1OrderStatus (params?: {}): Promise<Dict>;
    privatePostV1Orders (params?: {}): Promise<List>;
    privatePostV1Mytrades (params?: {}): Promise<List>;
    privatePostV1Notionalvolume (params?: {}): Promise<Dict>;
    privatePostV1Tradevolume (params?: {}): Promise<List>;
    privatePostV1ClearingNew (params?: {}): Promise<Dict>;
    privatePostV1ClearingStatus (params?: {}): Promise<Dict>;
    privatePostV1ClearingCancel (params?: {}): Promise<Dict>;
    privatePostV1ClearingConfirm (params?: {}): Promise<Dict>;
    privatePostV1Balances (params?: {}): Promise<Dict>;
    privatePostV1BalancesStaking (params?: {}): Promise<List>;
    privatePostV1NotionalbalancesCurrency (params?: {}): Promise<List>;
    privatePostV1Transfers (params?: {}): Promise<List>;
    privatePostV1AddressesNetwork (params?: {}): Promise<List>;
    privatePostV1DepositNetworkNewAddress (params?: {}): Promise<Dict>;
    privatePostV1DepositCurrencyNewAddress (params?: {}): Promise<Dict>;
    privatePostV1WithdrawCurrency (params?: {}): Promise<Dict>;
    privatePostV1AccountTransferCurrency (params?: {}): Promise<Dict>;
    privatePostV1PaymentsAddbank (params?: {}): Promise<Dict>;
    privatePostV1PaymentsMethods (params?: {}): Promise<Dict>;
    privatePostV1PaymentsSenWithdraw (params?: {}): Promise<Dict>;
    privatePostV1BalancesEarn (params?: {}): Promise<Dict>;
    privatePostV1EarnInterest (params?: {}): Promise<Dict>;
    privatePostV1EarnHistory (params?: {}): Promise<List>;
    privatePostV1ApprovedAddressesNetworkRequest (params?: {}): Promise<Dict>;
    privatePostV1ApprovedAddressesAccountNetwork (params?: {}): Promise<Dict>;
    privatePostV1ApprovedAddressesNetworkRemove (params?: {}): Promise<Dict>;
    privatePostV1Account (params?: {}): Promise<Dict>;
    privatePostV1AccountCreate (params?: {}): Promise<Dict>;
    privatePostV1AccountList (params?: {}): Promise<List>;
    privatePostV1Heartbeat (params?: {}): Promise<Dict>;
    privatePostV1Roles (params?: {}): Promise<Dict>;
    privatePostV1Custodyaccountfees (params?: {}): Promise<List>;
    privatePostV1WithdrawCurrencyCodeLowerCaseFeeEstimate (params?: {}): Promise<Dict>;
    privatePostV1PaymentsAddbankCad (params?: {}): Promise<Dict>;
    privatePostV1Transactions (params?: {}): Promise<Dict>;
    privatePostV1MarginAccount (params?: {}): Promise<Dict>;
    privatePostV1MarginRates (params?: {}): Promise<Dict>;
    privatePostV1MarginOrderPreview (params?: {}): Promise<Dict>;
    privatePostV1ClearingList (params?: {}): Promise<Dict>;
    privatePostV1ClearingBrokerList (params?: {}): Promise<Dict>;
    privatePostV1ClearingBrokerNew (params?: {}): Promise<Dict>;
    privatePostV1ClearingTrades (params?: {}): Promise<Dict>;
    privatePostV1InstantQuote (params?: {}): Promise<Dict>;
    privatePostV1InstantExecute (params?: {}): Promise<Dict>;
    privatePostV1AccountRename (params?: {}): Promise<Dict>;
    privatePostV1OauthRevokeByToken (params?: {}): Promise<Dict>;
    privatePostV1Margin (params?: {}): Promise<Dict>;
    privatePostV1PerpetualsFundingPayment (params?: {}): Promise<List>;
    privatePostV1PerpetualsFundingpaymentreportRecordsJson (params?: {}): Promise<List>;
    privatePostV1Positions (params?: {}): Promise<Dict>;
    privatePostV1PredictionMarketsOrder (params?: {}): Promise<Dict>;
    privatePostV1PredictionMarketsOrderBatch (params?: {}): Promise<Dict>;
    privatePostV1PredictionMarketsOrderCancel (params?: {}): Promise<Dict>;
    privatePostV1PredictionMarketsOrderBatchCancel (params?: {}): Promise<Dict>;
    privatePostV1PredictionMarketsOrdersActive (params?: {}): Promise<Dict>;
    privatePostV1PredictionMarketsOrdersHistory (params?: {}): Promise<Dict>;
    privatePostV1PredictionMarketsPositions (params?: {}): Promise<Dict>;
    privatePostV1PredictionMarketsPositionsSettled (params?: {}): Promise<Dict>;
    privatePostV1PredictionMarketsMetricsVolume (params?: {}): Promise<Dict>;
    privatePostV1PredictionMarketsTermsAccept (params?: {}): Promise<Dict>;
    privatePostV1PredictionMarketsMakerRebatePayouts (params?: {}): Promise<Dict>;
    privatePostV2Transfers (params?: {}): Promise<List>;
    privatePostV2WithdrawNetworkTicker (params?: {}): Promise<Dict>;
    privatePostV2WithdrawNetworkTickerFeeEstimate (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
